import store from '../store';
export default (router) => {
	router.beforeEach((to, from, next) => {
		// 让页面回到顶部
		document.documentElement.scrollTop = 0;
		if (JSON.stringify(store.state.userInfo) == '{}' && store.state.login) {
			store.dispatch({
				type: 'getUserInfo',
			});
		}
		next();
	});
	router.afterEach((to) => {
		store.dispatch({
			type:'navShow',
			navShow:false
		})
		document.title = to.query.title || to.meta?.title || '';
	});
};
